import { render, staticRenderFns } from "./UserContributionsView.vue?vue&type=template&id=2af42fe2&scoped=true&"
import script from "./UserContributionsView.vue?vue&type=script&lang=js&"
export * from "./UserContributionsView.vue?vue&type=script&lang=js&"
import style0 from "./UserContributionsView.vue?vue&type=style&index=0&id=2af42fe2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af42fe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
